import React from 'react';

const GlobalSearchDropdownSearchResult = props => {
  return (
    <div className="global-dropdown-search-result" dangerouslySetInnerHTML={{ __html: props.nodeLink }} />
  );
};

export default GlobalSearchDropdownSearchResult;
